module.exports = __webpack_public_path__ + "img/block-1.774abf7f.jpg";